import * as React from 'react';

function ShipperAvatarIcon(props: React.SVGProps<SVGSVGElement>) {
  return (
    <svg
      width="40"
      height="40"
      viewBox="0 0 40 40"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <rect width="40" height="40" rx="20" fill="#81899B" />
      <path
        d="M23.0917 20.5917C23.9087 19.9489 24.505 19.0674 24.7977 18.0699C25.0904 17.0725 25.0649 16.0085 24.7248 15.0262C24.3847 14.0439 23.7469 13.192 22.9001 12.589C22.0532 11.9861 21.0395 11.6621 20 11.6621C18.9605 11.6621 17.9468 11.9861 17.0999 12.589C16.2531 13.192 15.6153 14.0439 15.2752 15.0262C14.9351 16.0085 14.9096 17.0725 15.2023 18.0699C15.495 19.0674 16.0913 19.9489 16.9083 20.5917C15.5084 21.1525 14.2869 22.0828 13.3741 23.2833C12.4612 24.4837 11.8913 25.9094 11.725 27.4083C11.713 27.5178 11.7226 27.6285 11.7534 27.7342C11.7841 27.8399 11.8354 27.9385 11.9043 28.0244C12.0433 28.1979 12.2457 28.309 12.4667 28.3333C12.6877 28.3576 12.9093 28.2932 13.0828 28.1541C13.2562 28.015 13.3674 27.8127 13.3917 27.5917C13.5747 25.9627 14.3514 24.4582 15.5735 23.3657C16.7956 22.2731 18.3774 21.6692 20.0167 21.6692C21.6559 21.6692 23.2377 22.2731 24.4598 23.3657C25.6819 24.4582 26.4587 25.9627 26.6417 27.5917C26.6643 27.7964 26.762 27.9855 26.9159 28.1225C27.0698 28.2595 27.269 28.3346 27.475 28.3333H27.5667C27.7851 28.3082 27.9848 28.1977 28.1221 28.026C28.2595 27.8543 28.3234 27.6353 28.3 27.4167C28.1329 25.9135 27.5599 24.4841 26.6424 23.2818C25.7249 22.0795 24.4974 21.1496 23.0917 20.5917ZM20 20C19.3407 20 18.6963 19.8045 18.1481 19.4382C17.5999 19.072 17.1727 18.5514 16.9204 17.9423C16.6681 17.3332 16.6021 16.663 16.7307 16.0164C16.8593 15.3698 17.1768 14.7758 17.643 14.3096C18.1091 13.8435 18.7031 13.526 19.3497 13.3974C19.9963 13.2688 20.6665 13.3348 21.2756 13.5871C21.8847 13.8394 22.4053 14.2666 22.7716 14.8148C23.1378 15.3629 23.3333 16.0074 23.3333 16.6667C23.3333 17.5507 22.9821 18.3986 22.357 19.0237C21.7319 19.6488 20.8841 20 20 20Z"
        fill="white"
      />
      <path
        d="M20 40C31.0457 40 40 31.0457 40 20C40 8.9543 31.0457 0 20 0C8.9543 0 0 8.9543 0 20C0 31.0457 8.9543 40 20 40Z"
        fill="#F9AA1A"
      />
      <mask
        id="mask0_3349_70509"
        style={{
          maskType: 'alpha',
        }}
        maskUnits="userSpaceOnUse"
        x="0"
        y="0"
        width="40"
        height="40"
      >
        <path
          d="M20 40C31.0457 40 40 31.0457 40 20C40 8.9543 31.0457 0 20 0C8.9543 0 0 8.9543 0 20C0 31.0457 8.9543 40 20 40Z"
          fill="#EAEAEA"
        />
      </mask>
      <g mask="url(#mask0_3349_70509)">
        <path
          d="M15.8242 7.61766C15.8242 7.61766 15.9206 5.69047 17.821 5.05878C21.488 3.84357 25.6743 6.50417 25.5084 7.79967C25.5084 7.79967 27.1518 7.79968 26.3114 12.0395C25.8992 14.1166 25.6797 18.0566 23.4581 18.4367C21.2311 18.8168 18.5384 16.729 18.5384 16.729L15.8242 7.61766Z"
          fill="#021337"
        />
        <path
          d="M16.0866 7.32318C16.0866 7.32318 13.3671 6.43453 14.6144 13.2011C14.8339 14.4056 14.941 17.5373 17.0877 18.2332C19.2343 18.9292 19.32 14.5984 19.32 14.5984L16.0866 7.32318Z"
          fill="#021337"
        />
        <path
          d="M37.4088 44.8554C37.2107 45.1873 36.9859 45.5032 36.745 45.8083C35.8777 46.9164 34.7535 47.8747 33.4741 48.7098C32.5694 49.2987 31.5897 49.8233 30.5672 50.2944C27.2268 51.8254 23.4259 52.7569 20.3317 53.3136C16.8467 53.94 14.261 54.0952 14.261 54.0952L6.03297 49.8179L5.22462 49.395L2.58008 48.0192V37.9871C2.58008 37.9871 2.66038 26.9432 14.6625 25.3961L25.9259 25.3479C25.9259 25.3479 25.942 25.3533 25.9687 25.364C26.0811 25.3961 26.4291 25.5085 26.927 25.6959C28.9773 26.4668 33.64 28.576 35.6796 32.4197C36.5255 34.0096 36.9858 36.2954 37.216 38.6777C37.4195 40.8083 37.4462 43.0139 37.4088 44.8554Z"
          fill="white"
        />
        <path
          d="M25.9205 25.3532C24.6732 26.3917 23.4634 27.0234 22.3285 27.366H22.3231C18.5704 28.4902 15.5779 26.472 14.4109 25.4977C14.4965 25.4656 14.5822 25.4335 14.6625 25.4013C14.8873 25.3103 15.0961 25.2033 15.2942 25.0855C18.2599 23.2654 17.7192 19.0523 17.7192 19.0523H22.9869C22.9869 19.0523 22.8852 19.9731 23.0083 21.1669C23.1796 22.9067 23.8274 24.4431 25.9205 25.3532Z"
          fill="#E8EAED"
        />
        <path
          d="M23.0029 21.1669C22.6925 21.6968 22.2535 22.0662 21.6271 22.1198C19.17 22.3232 17.7942 19.9142 17.8209 19.6893L17.9494 19.0523H22.9815C22.9815 19.0523 22.8852 19.9731 23.0029 21.1669Z"
          fill="#021337"
        />
        <path
          d="M26.3114 14.4428C26.3114 13.7575 25.8242 13.1954 25.2247 13.1954C24.6251 13.1954 24.1379 13.7522 24.1379 14.4428C24.1379 15.1333 24.6251 15.9952 25.2247 15.9952C25.8242 15.9952 26.3114 15.128 26.3114 14.4428Z"
          fill="#E8EAED"
        />
        <path
          d="M24.9409 14.871L24.866 14.8657C24.866 14.855 24.957 14.0466 25.7118 14.0252V14.1002C25.0266 14.1162 24.9409 14.8603 24.9409 14.871Z"
          fill="#021337"
        />
        <path
          d="M25.6851 14.7532C25.5567 14.6193 25.4282 14.5604 25.2944 14.5658C25.0963 14.5765 24.9625 14.7478 24.9625 14.7532L24.9036 14.705C24.9089 14.6943 25.0588 14.5016 25.2944 14.4908C25.4496 14.4801 25.5995 14.5551 25.744 14.705L25.6851 14.7532Z"
          fill="#021337"
        />
        <path
          d="M14.261 14.4428C14.261 13.7575 14.7481 13.1954 15.3477 13.1954C15.9473 13.1954 16.4344 13.7522 16.4344 14.4428C16.4344 15.1333 15.9473 15.9952 15.3477 15.9952C14.7428 15.9952 14.261 15.128 14.261 14.4428Z"
          fill="#E8EAED"
        />
        <path
          d="M15.7494 14.871L15.8243 14.8657C15.8243 14.855 15.7333 14.0466 14.9785 14.0252V14.1002C15.6637 14.1162 15.7494 14.8603 15.7494 14.871Z"
          fill="#021337"
        />
        <path
          d="M15.0052 14.7532C15.1337 14.6193 15.2621 14.5604 15.396 14.5658C15.594 14.5765 15.7279 14.7478 15.7279 14.7532L15.7868 14.705C15.7814 14.6943 15.6315 14.5016 15.396 14.4908C15.2407 14.4801 15.0908 14.5551 14.9463 14.705L15.0052 14.7532Z"
          fill="#021337"
        />
        <path
          d="M23.3884 19.2234C22.5854 20.1496 21.5683 20.7438 20.3477 20.7224C19.1272 20.7438 18.1101 20.1496 17.3071 19.2234C17.3017 19.2181 17.2964 19.2127 17.291 19.2074C15.851 17.3873 15.5565 14.7374 15.9473 11.5789C16.2257 9.3091 18.367 8.4258 19.5555 8.10996C20.0747 7.97077 20.6154 7.97077 21.1347 8.10996C22.3231 8.4258 24.4644 9.30374 24.7428 11.5789C25.139 14.7427 24.8392 17.4033 23.3884 19.2234Z"
          fill="#E8EAED"
        />
        <path
          d="M21.9859 14.7479C22.1308 14.7479 22.2483 14.6305 22.2483 14.4856C22.2483 14.3407 22.1308 14.2233 21.9859 14.2233C21.8411 14.2233 21.7236 14.3407 21.7236 14.4856C21.7236 14.6305 21.8411 14.7479 21.9859 14.7479Z"
          fill="#021337"
        />
        <path
          d="M18.5382 14.7479C18.6831 14.7479 18.8005 14.6305 18.8005 14.4856C18.8005 14.3407 18.6831 14.2233 18.5382 14.2233C18.3933 14.2233 18.2759 14.3407 18.2759 14.4856C18.2759 14.6305 18.3933 14.7479 18.5382 14.7479Z"
          fill="#021337"
        />
        <path
          d="M23.3831 12.3175C23.3831 12.3175 22.7568 12.3443 21.9324 12.3496C21.1079 12.355 20.8992 12.3443 20.9688 12.007C21.0383 11.6697 21.8681 11.6805 22.382 11.7929C22.896 11.9053 23.3831 12.3175 23.3831 12.3175Z"
          fill="#021337"
        />
        <path
          d="M17.082 12.3175C17.082 12.3175 17.7084 12.3443 18.5328 12.3496C19.3572 12.355 19.566 12.3443 19.4964 12.007C19.4268 11.6697 18.597 11.6805 18.0831 11.7929C17.5692 11.9053 17.082 12.3175 17.082 12.3175Z"
          fill="#021337"
        />
        <path
          d="M20.1709 16.3221C20.0746 16.3221 19.9836 16.3061 19.9354 16.2579C19.9086 16.2365 19.8818 16.1936 19.8926 16.1294C19.93 15.8885 20.0692 14.9356 20.0692 14.9303L20.1442 14.941C20.1442 14.9517 20.005 15.9046 19.9675 16.1455C19.9621 16.1829 19.9729 16.199 19.9836 16.2097C20.0532 16.2739 20.3048 16.2525 20.4439 16.2204L20.46 16.2954C20.4386 16.29 20.3048 16.3221 20.1709 16.3221Z"
          fill="#021337"
        />
        <path
          d="M20.4334 16.8839C20.2674 16.8839 20.1603 16.8571 20.155 16.8571C20.1336 16.8517 20.1175 16.8303 20.1229 16.8036C20.1282 16.7822 20.1496 16.7661 20.1764 16.7714C20.2139 16.7821 21.14 16.9802 21.6218 16.1076C21.6325 16.0862 21.6593 16.0809 21.6807 16.0916C21.7021 16.1023 21.7074 16.1291 21.6967 16.1505C21.3488 16.7768 20.7706 16.8839 20.4334 16.8839Z"
          fill="#021337"
        />
        <path
          d="M21.0224 17.0607C21.001 17.0607 20.9849 17.0446 20.9796 17.0285C20.9742 17.0071 20.9903 16.9803 21.0117 16.9803C21.0759 16.9696 21.1402 16.9429 21.1937 16.9107C21.2151 16.9 21.2419 16.9054 21.2526 16.9268C21.2633 16.9482 21.2579 16.975 21.2365 16.9857C21.1723 17.0232 21.1027 17.0499 21.0277 17.066C21.0277 17.0606 21.0224 17.0607 21.0224 17.0607Z"
          fill="#021337"
        />
        <path
          d="M24.459 10.2032L24.7481 14.4858L25.0586 13.0404C25.0586 13.0458 25.974 11.1239 24.459 10.2032Z"
          fill="#021337"
        />
        <path
          d="M16.2311 9.70563L15.8296 14.4861L15.6369 13.0407C15.6315 13.0461 14.7161 11.1243 16.2311 9.70563Z"
          fill="#021337"
        />
        <path
          d="M25.9207 25.3534C25.9207 25.3534 24.2718 28.0354 20.1658 27.9979C16.0598 27.9551 14.229 25.4658 14.229 25.4658C14.229 25.4658 14.7429 25.1071 15.3478 24.5343C15.926 23.9883 16.5845 23.2442 16.9538 22.4305C16.9538 22.4305 17.0984 22.2645 18.0995 22.5322C19.1005 22.8052 20.2194 23.1103 21.7504 22.8427C23.2815 22.575 23.3778 22.5322 23.4849 22.6125C23.5705 22.6821 24.1541 23.9347 25.2033 24.8448C25.4228 25.0322 25.6637 25.2035 25.9207 25.3534Z"
          fill="white"
        />
        <path
          d="M23.2438 47.7301L19.3091 51.017L17.2588 49.5984L15.8723 48.6401L15.3477 48.2761C15.3477 48.2761 15.428 47.5159 15.9205 45.123C16.065 44.4324 16.2417 43.608 16.4611 42.6283C16.5789 42.1037 16.7074 41.5309 16.8519 40.9099C17.0286 40.1391 17.2106 39.2932 17.3819 38.4099C17.5372 37.6283 17.6871 36.8146 17.8316 35.9902C18.0671 34.6412 18.292 33.2654 18.4954 31.9752C18.6239 31.1562 18.7417 30.3692 18.8487 29.6358C18.9611 28.8703 19.0629 28.169 19.1485 27.5587C19.3519 26.108 19.4697 25.1819 19.4697 25.1819H20.808L20.9151 26.1615L21.0971 27.8478L21.3006 29.7322L21.6485 32.9495L21.8519 34.8339L22.1999 38.0512L22.4033 39.9356L22.7513 43.1583L22.9547 45.0373L23.2438 47.7301Z"
          fill="#021337"
        />
        <path
          d="M20.9153 26.1615C20.4335 26.5577 19.7857 27.0769 19.1487 27.5587C19.3521 26.108 19.4699 25.1819 19.4699 25.1819H20.8082L20.9153 26.1615Z"
          fill="#021337"
        />
        <path
          d="M18.8005 25.0268C18.8005 25.0268 19.8819 25.9208 20.1228 25.9583C20.3637 25.9958 21.7288 24.6575 21.7288 24.6575L20.9097 23.196H19.1485L18.8005 25.0268Z"
          fill="#F9AA1A"
        />
        <path
          d="M25.2031 24.8447C23.8327 25.5513 22.216 26.349 21.9858 26.3329C21.5789 26.2954 20.1175 23.5064 20.1175 23.5064C20.1175 23.5064 18.6185 26.3383 18.0886 26.3329C17.5104 26.3276 16.3755 25.273 15.3477 24.5289C15.9258 23.9828 16.5843 23.2387 16.9537 22.425C16.9537 22.425 17.0982 22.259 18.0993 22.5267C19.1003 22.7997 20.2192 23.1049 21.7502 22.8372C23.2813 22.5695 23.3776 22.5267 23.4847 22.607C23.5704 22.682 24.1539 23.9346 25.2031 24.8447Z"
          fill="white"
        />
        <path
          d="M5.22461 49.4005L9.86058 31.5739L6.03296 49.8181L5.22461 49.4005Z"
          fill="#E8EAED"
        />
        <path
          d="M30.5673 50.2944C31.5523 41.4614 29.5823 32.3983 29.5823 32.3983L33.4688 48.7152C32.5694 49.304 31.5898 49.8286 30.5673 50.2944Z"
          fill="#E8EAED"
        />
        <path
          d="M21.3007 29.7323L18.4956 31.9807C18.6241 31.1616 18.7419 30.3747 18.8489 29.6413L21.0973 27.8479L21.3007 29.7323Z"
          fill="#F9AA1A"
        />
        <path
          d="M21.8521 34.8339L17.3821 38.4099C17.5373 37.6283 17.6872 36.8146 17.8318 35.9902L21.6487 32.9442L21.8521 34.8339Z"
          fill="#F9AA1A"
        />
        <path
          d="M22.4036 39.9358L15.926 45.1232C16.0706 44.4326 16.2472 43.6082 16.4667 42.6286L22.2055 38.0515L22.4036 39.9358Z"
          fill="#F9AA1A"
        />
        <path
          d="M18.0619 26.3973C17.9548 26.3973 17.6551 26.2795 16.5897 25.5247C15.942 25.0643 15.3157 24.5825 15.3103 24.5771L15.3853 24.4808C16.5683 25.3962 17.896 26.3116 18.0673 26.2741C18.2332 26.1885 19.3842 24.5075 20.0694 23.469L20.1283 23.3833L20.1765 23.4797C20.1818 23.485 20.5512 24.2238 20.9634 24.9304C21.7557 26.2902 21.9484 26.2795 21.9698 26.2688C22.3446 26.1564 25.1497 24.802 25.1765 24.7859L25.23 24.893C25.1122 24.9465 22.3874 26.2688 22.0019 26.3812C21.9163 26.408 21.7129 26.4668 20.8563 24.984C20.5298 24.4165 20.2246 23.8384 20.1122 23.6189C19.7696 24.1328 18.351 26.2581 18.1154 26.3758C18.1047 26.3919 18.094 26.3973 18.0619 26.3973Z"
          fill="#E8EAED"
        />
        <path
          d="M37.4088 44.8554C37.2107 45.1873 36.9859 45.5032 36.745 45.8083C36.745 44.4967 36.761 43.0888 36.7985 41.5899C37.0715 29.4164 26.9216 25.6959 26.9216 25.6959C28.972 26.4668 33.6347 28.576 35.6743 32.4196C36.5201 34.0096 36.9805 36.2954 37.2107 38.6777C37.4195 40.8083 37.4462 43.0139 37.4088 44.8554Z"
          fill="#E09917"
        />
        <path
          d="M25.0212 11.9755C19.4699 12.7945 17.6872 9.56649 17.6872 9.56649C17.2589 12.0344 15.8242 12.6714 15.8242 12.6714C15.8242 12.6714 15.3853 11.2849 15.3424 10.2089C15.2996 9.12752 17.3821 7.25385 19.8874 6.98084C22.3928 6.70782 24.684 8.6243 24.684 8.6243L24.9731 11.6436C22.3714 12.2431 19.6519 10.7228 19.6519 10.7228C21.5576 12.0397 24.1379 11.9434 24.9945 11.8684L25.0212 11.9755Z"
          fill="#021337"
        />
      </g>
    </svg>
  );
}

export default ShipperAvatarIcon;
